import { useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import api from "../lib/api";
import SEOHead from "../components/SEOHead";

// Handles redirect from Emergent OAuth: URL hash contains session_id
// REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
export default function AuthCallback() {
  const navigate = useNavigate();
  const processed = useRef(false);

  useEffect(() => {
    if (processed.current) return;
    processed.current = true;

    const hash = window.location.hash;
    const m = hash.match(/session_id=([^&]+)/);
    if (!m) { navigate("/login"); return; }
    const sessionId = m[1];

    (async () => {
      try {
        const { data } = await api.post("/auth/emergent-session", { session_id: sessionId });
        if (data.session_token) localStorage.setItem("sdf_token", data.session_token);
        // Clean URL hash and reload to refresh AuthContext
        window.history.replaceState(null, "", "/");
        window.location.href = "/";
      } catch {
        navigate("/login");
      }
    })();
  }, [navigate]);

  return (
    <div className="text-center py-32 text-brand-muted" data-testid="auth-callback">
      <SEOHead title="Signing in… | Sri Durga Foods" noindex />
      Completing sign in…
    </div>
  );
}
